import { type UseFormRegisterReturn } from "react-hook-form";

import { StyledInput } from "./styles";

type InputProps = {
  id?: string;
  type:
    | "text"
    | "email"
    | "number"
    | "range"
    | "password"
    | "checkbox"
    | "radio"
    | "textarea"; // expand down below later when needed
  label: string;
  showLabel: boolean;
  onChange?: () => void;
  error?: any;
  register: UseFormRegisterReturn;
  children?: any;
  disabled?: boolean;
};

// Checkbox needs reworking properly later
// https://moderncss.dev/pure-css-custom-checkbox-style/ - this looks good !

const Input = ({
  id,
  type,
  label,
  showLabel,
  onChange,
  register,
  error,
  disabled = false,
}: InputProps) => {
  const inputFieldContainerClasses = `input-field ${type}-field`;
  if (
    type === "text" ||
    type === "number" ||
    type === "password" ||
    type === "email"
  ) {
    return (
      <div className={inputFieldContainerClasses}>
        {showLabel && <label htmlFor={id}>{label}</label>}
        <StyledInput
          id={id}
          type={type}
          onChange={onChange}
          className={error ? "invalid-input" : ""}
          disabled={disabled}
          {...register}
        />
        {error && <span className="form-error">{error}</span>}
      </div>
    );
  } else if (type === "checkbox") {
    return (
      <div className={inputFieldContainerClasses}>
        <label htmlFor={id}>
          <StyledInput type="checkbox" id={id} disabled={disabled} {...register} />
          {label}
        </label>
      </div>
    );
  }
};

export default Input;
